var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBorderZone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 44,
    viewBox: "0 0 1440 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_343_20)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 44,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.3167,
    y: -12.0164,
    width: 11.7888,
    height: 76.18,
    transform: "rotate(45 29.3167 -12.0164)",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.3164,
    y: -12.0164,
    width: 11.7888,
    height: 86.3306,
    transform: "rotate(45 59.3164 -12.0164)",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.3164,
    y: -12.0164,
    width: 11.7888,
    height: 90.9392,
    transform: "rotate(45 89.3164 -12.0164)",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.316,
    y: -12.0164,
    width: 11.7888,
    height: 90.9392,
    transform: "rotate(45 119.316 -12.0164)",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.316,
    y: -12.0164,
    width: 11.7888,
    height: 90.9392,
    transform: "rotate(45 149.316 -12.0164)",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.316,
    y: -12.0164,
    width: 11.7888,
    height: 90.9392,
    transform: "rotate(45 179.316 -12.0164)",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.316,
    y: -12.0164,
    width: 11.7888,
    height: 90.9392,
    transform: "rotate(45 209.316 -12.0164)",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.316,
    y: -12.0164,
    width: 11.7888,
    height: 90.9392,
    transform: "rotate(45 239.316 -12.0164)",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.316,
    y: -12.0164,
    width: 11.7888,
    height: 90.9392,
    transform: "rotate(45 269.316 -12.0164)",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.316,
    y: -12.0164,
    width: 11.7888,
    height: 90.9392,
    transform: "rotate(45 299.316 -12.0164)",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.316,
    y: -12.0164,
    width: 11.7888,
    height: 90.9392,
    transform: "rotate(45 329.316 -12.0164)",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.316,
    y: -12.0164,
    width: 11.7888,
    height: 90.9392,
    transform: "rotate(45 359.316 -12.0164)",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.316,
    y: -12.0164,
    width: 11.7888,
    height: 90.9392,
    transform: "rotate(45 389.316 -12.0164)",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 419.316,
    y: -12.0164,
    width: 11.7888,
    height: 90.9392,
    transform: "rotate(45 419.316 -12.0164)",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449.316,
    y: -12.0164,
    width: 11.7888,
    height: 90.9392,
    transform: "rotate(45 449.316 -12.0164)",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 479.316,
    y: -12.0164,
    width: 11.7888,
    height: 90.9392,
    transform: "rotate(45 479.316 -12.0164)",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 509.316,
    y: -12.0164,
    width: 11.7888,
    height: 90.9392,
    transform: "rotate(45 509.316 -12.0164)",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 539.316,
    y: -12.0164,
    width: 11.7888,
    height: 90.9392,
    transform: "rotate(45 539.316 -12.0164)",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 569.316,
    y: -12.0164,
    width: 11.7888,
    height: 90.9392,
    transform: "rotate(45 569.316 -12.0164)",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599.316,
    y: -12.0164,
    width: 11.7888,
    height: 90.9392,
    transform: "rotate(45 599.316 -12.0164)",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 629.316,
    y: -12.0164,
    width: 11.7888,
    height: 90.9392,
    transform: "rotate(45 629.316 -12.0164)",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 659.316,
    y: -12.0164,
    width: 11.7888,
    height: 90.9392,
    transform: "rotate(45 659.316 -12.0164)",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 689.316,
    y: -12.0164,
    width: 11.7888,
    height: 90.9392,
    transform: "rotate(45 689.316 -12.0164)",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 719.316,
    y: -12.0164,
    width: 11.7888,
    height: 90.9392,
    transform: "rotate(45 719.316 -12.0164)",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 749.316,
    y: -12.0164,
    width: 11.7888,
    height: 90.9392,
    transform: "rotate(45 749.316 -12.0164)",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 779.316,
    y: -12.0164,
    width: 11.7888,
    height: 90.9392,
    transform: "rotate(45 779.316 -12.0164)",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 809.316,
    y: -12.0164,
    width: 11.7888,
    height: 90.9392,
    transform: "rotate(45 809.316 -12.0164)",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 839.316,
    y: -12.0164,
    width: 11.7888,
    height: 90.9392,
    transform: "rotate(45 839.316 -12.0164)",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 869.316,
    y: -12.0164,
    width: 11.7888,
    height: 90.9392,
    transform: "rotate(45 869.316 -12.0164)",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 899.316,
    y: -12.0164,
    width: 11.7888,
    height: 90.9392,
    transform: "rotate(45 899.316 -12.0164)",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 929.316,
    y: -12.0164,
    width: 11.7888,
    height: 90.9392,
    transform: "rotate(45 929.316 -12.0164)",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 959.316,
    y: -12.0164,
    width: 11.7888,
    height: 90.9392,
    transform: "rotate(45 959.316 -12.0164)",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 989.316,
    y: -12.0164,
    width: 11.7888,
    height: 90.9392,
    transform: "rotate(45 989.316 -12.0164)",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1019.32,
    y: -12.0164,
    width: 11.7888,
    height: 90.9392,
    transform: "rotate(45 1019.32 -12.0164)",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1049.32,
    y: -12.0164,
    width: 11.7888,
    height: 90.9392,
    transform: "rotate(45 1049.32 -12.0164)",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1079.32,
    y: -12.0164,
    width: 11.7888,
    height: 90.9392,
    transform: "rotate(45 1079.32 -12.0164)",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1109.32,
    y: -12.0164,
    width: 11.7888,
    height: 90.9392,
    transform: "rotate(45 1109.32 -12.0164)",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1139.32,
    y: -12.0164,
    width: 11.7888,
    height: 90.9392,
    transform: "rotate(45 1139.32 -12.0164)",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1169.32,
    y: -12.0164,
    width: 11.7888,
    height: 90.9392,
    transform: "rotate(45 1169.32 -12.0164)",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1199.32,
    y: -12.0164,
    width: 11.7888,
    height: 90.9392,
    transform: "rotate(45 1199.32 -12.0164)",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1229.32,
    y: -12.0164,
    width: 11.7888,
    height: 90.9392,
    transform: "rotate(45 1229.32 -12.0164)",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1259.32,
    y: -12.0164,
    width: 11.7888,
    height: 90.9392,
    transform: "rotate(45 1259.32 -12.0164)",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1289.32,
    y: -12.0164,
    width: 11.7888,
    height: 90.9392,
    transform: "rotate(45 1289.32 -12.0164)",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1319.32,
    y: -12.0164,
    width: 11.7888,
    height: 90.9392,
    transform: "rotate(45 1319.32 -12.0164)",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1349.32,
    y: -12.0164,
    width: 11.7888,
    height: 90.9392,
    transform: "rotate(45 1349.32 -12.0164)",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1379.32,
    y: -12.0164,
    width: 11.7888,
    height: 90.9392,
    transform: "rotate(45 1379.32 -12.0164)",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1409.32,
    y: -12.0164,
    width: 11.7888,
    height: 90.9392,
    transform: "rotate(45 1409.32 -12.0164)",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1439.32,
    y: -12.0164,
    width: 11.7888,
    height: 90.9392,
    transform: "rotate(45 1439.32 -12.0164)",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1469.32,
    y: -12.0164,
    width: 11.7888,
    height: 90.9392,
    transform: "rotate(45 1469.32 -12.0164)",
    fill: "#FFD700"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_343_20"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorderZone);
export default __webpack_public_path__ + "static/media/borderZone.77b11fbc10d15b4a09daf345ad5745eb.svg";
export { ForwardRef as ReactComponent };